import { gql } from "@apollo/client";

export default gql`
  mutation deleteCouponCode($data: DeleteCouponCodeInput!){
    deleteCouponCode(data: $data){
        success
        data{
            _id
            customer
            name
            code
            status
            valueType
            value
            maxRedemptions
            timesRedeemed
            usageType
            usageLimit
            usageCount
            expiredAt
            createdAt
            updatedAt
        }
        code
        message
    }
}
`
